import Glide from '@glidejs/glide'
import {Controls, Breakpoints} from '@glidejs/glide/dist/glide.modular.esm'
import {PriceHandler} from "../bricks/eFormOfferTable";

let glideMulti = null;
let firstButton = '';

(function () {
    if (document.querySelector('.slide-glide-next-prev')) {

        initGlide();

        window.addEventListener('DOMContentLoaded', () => {
            if (document.querySelector('.slide-glide-next-prev')) {
                let divSlide = document.querySelector('.slide-glide-next-prev');

                if (divSlide.closest('.panel')) {
                    let panelDiv = divSlide.closest('.panel');
                    let nextPanel = null;
                    if(panelDiv.nextElementSibling){
                        nextPanel = panelDiv.nextElementSibling;
                    }
                    else {
                        nextPanel = panelDiv.parentElement.nextElementSibling.querySelector('.panel');
                    }

                    let divSnippetElement = document.querySelector('.form-builder-snippet-element .panel-button-next button');
                    const originalText = divSnippetElement.textContent;

                    function handleActiveClass(mutationsList, observer) {
                        mutationsList.forEach(mutation => {
                            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                                if (panelDiv.classList.contains('active')) {
                                    restartGlide();
                                    observer.disconnect();
                                    hideElements(panelDiv, divSlide);
                                }
                            }
                        });
                    }

                    function handleActiveClassNext(mutationsList1, observer) {
                        mutationsList1.forEach(mutation => {
                            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                                if (nextPanel.classList.contains('active')) {
                                    restoreFirstVersion();
                                }

                            }
                        });
                    }

                    const observer = new MutationObserver(handleActiveClass);
                    observer.observe(panelDiv, {attributes: true, subtree: true });

                    const observerNext = new MutationObserver(handleActiveClassNext);
                    observerNext.observe(nextPanel, {attributes: true, subtree: true });
                }
            }
        });
    }
})();

function restoreFirstVersion(){
    let panelButtonNextNew = document.querySelector('.form-builder-snippet-element .panel-button-next-new');
    let panelButtonNext = document.querySelector('.form-builder-snippet-element .panel-button-next');
    let button = panelButtonNext.querySelector('button');
    let snippetElementWithButtons = document.querySelector('.form-builder-snippet-element .panel-button-send');

    panelButtonNext.classList.remove('choose-offer');
    button.innerHTML = firstButton.innerHTML;
    snippetElementWithButtons.parentElement.appendChild(panelButtonNext);
    if(panelButtonNextNew){
        panelButtonNextNew.remove();
    }
}

function initGlide() {
    glideMulti = new Glide('.glide', {
        type: 'carousel',
        perView: 3,
        focusAt: 'center',
        rewind: true,
        gap: -80,
        keyboard: false,
        dragThreshold: false,
        swipeThreshold: false,
        breakpoints: {
            768: {
                perView: 1,
                gap: 10,
            },
        },

    });
    glideMulti.on('mount.after', function (event) {
        activeSlide(glideMulti);
    });

    glideMulti.on('run.after', function (event) {
        activeSlide(glideMulti);
    });

    glideMulti.mount({Controls, Breakpoints});

    openOfert();

}

function activeSlide(glide) {
    const myPriceHandler = new PriceHandler();
    let activeSlide = document.querySelector('.glide__slide--active');
    let glideSlidesNoActive = document.querySelectorAll('.glide__slide:not(.glide__slide--active)');
    let listGlideSlides = document.querySelectorAll('.glide__slide');

    glideSlidesNoActive.forEach(slide => {
        let divSlideParent = document.querySelector('.slide-glide-next-prev').parentElement;

        if (divSlideParent.querySelector('.div-fetch')) {
            divSlideParent.querySelector('.div-fetch').remove();
        }
    });

    getPreviousAndNextActiveElement(activeSlide, listGlideSlides);
}

function getPreviousAndNextActiveElement(activeElement, listSlide) {
    listSlide.forEach(slide => {
        slide.classList.remove('glide__slide--prev', 'glide__slide--next');
    });
    let previousElement = activeElement.previousElementSibling;
    let nextElement = activeElement.nextElementSibling;
    previousElement.classList.add('glide__slide--prev');
    nextElement.classList.add('glide__slide--next');
}

function restartGlide() {
    if (glideMulti) {
        glideMulti.destroy();
    }
    initGlide();
}


function showListButton(list, button){
    list.forEach(elemDiv =>{
        elemDiv.classList.remove('d-none');
    });
    if (button !== null){
        button.classList.remove('d-none');
    }
}

function hideListButton(list, button){
    list.forEach(elemDiv =>{
        elemDiv.classList.add('d-none');
    });
    if (button !== null){
        button.classList.add('d-none');
    }
}
function createList(panelActive){
    let listFormGroup = Array.from(panelActive.querySelectorAll('.panel > .form-group'));
    let listFormGroupCopy = Array.from(panelActive.querySelectorAll('.panel > .form-group'));
    let foundSlideGlideNextPrev = false;
    listFormGroupCopy.forEach((elemDiv) => {

        if (foundSlideGlideNextPrev === false) {
            if (elemDiv.querySelector('.slide-glide-next-prev')) {
                foundSlideGlideNextPrev = true;
            }
            let indexToRemove = listFormGroup.indexOf(elemDiv);
            if (indexToRemove !== -1) {
                listFormGroup.splice(indexToRemove, 1);
            }

        }
    });
    return listFormGroup;
}

function hideElements(panelActive, divSlide){
    let listFormGroup = createList( panelActive);
    let listButtonSlide = divSlide.querySelectorAll('button');
    let nextPrev = divSlide.querySelectorAll('.glide__arrow');
    let snippetElementWithButton = null;
    let buttonNext = null;

    let parentDivBackOffer = document.createElement("div");
    let newDivBackOffer = document.createElement("div");
    newDivBackOffer.classList.add('back-to-offer');
    newDivBackOffer.innerHTML = 'Wracam do ofert';
    parentDivBackOffer.classList.add('d-flex', 'justify-content-center', 'panel-button-next-new');
    parentDivBackOffer.appendChild(newDivBackOffer);

    if(document.querySelector('.form-builder-snippet-element .panel-button-next')){
        buttonNext = document.querySelector('.form-builder-snippet-element .panel-button-next');
        snippetElementWithButton = buttonNext.closest('.form-builder-snippet-element');

        if(buttonNext.querySelector('button')){
            let button = buttonNext.querySelector('button');
            if(button.children){
                let children = button.children[0];
                firstButton = children.cloneNode(true);
            }
            else {
                firstButton = button.cloneNode(true);
            }
        }
    }

    hideListButton(listFormGroup, snippetElementWithButton)

    nextPrev.forEach((button) => {
        button.addEventListener('click', function () {
            hideListButton(listFormGroup, snippetElementWithButton);
        });
    });

    listButtonSlide.forEach((button) => {
        button.addEventListener('click', function () {

            if (snippetElementWithButton !== null){
                let button = buttonNext.querySelector('button');
                buttonNext.classList.add('choose-offer');
                button.textContent = 'Wybieram ofertę';
                parentDivBackOffer.appendChild(buttonNext);
                addDatasetToButtons(this, parentDivBackOffer);
                snippetElementWithButton.appendChild(parentDivBackOffer);
            }
        });
    });

    if(newDivBackOffer){
        newDivBackOffer.addEventListener('click', function () {
            hideListButton(listFormGroup, snippetElementWithButton);
            if(document.querySelector('.div-fetch')){
                document.querySelector('.div-fetch').remove();
            }
        });
    }

}

//Add info dataset for tag manager
//geting class *-oferta-btn from the main button, remove -btn, setting for div.back-to-offer and div.choose-offer dataset with value *-oferta. 
function addDatasetToButtons(elemDiv, parentDivBackOffer){
    let classArray = [... elemDiv.classList];
    let item = classArray.find(item => item.includes('oferta-btn')); 
    var classtoAdd = '';
    if(item)
    {
        classtoAdd = item.replace("\-btn","")
    }

    parentDivBackOffer.querySelector('.back-to-offer').dataset.oferta = classtoAdd;
    parentDivBackOffer.querySelector('.choose-offer').dataset.oferta = classtoAdd;
}

function openOfert() {
    const myPriceHandler = new PriceHandler();

    let divGlideParent = document.querySelector('.slide-glide-next-prev').parentElement;

    let buttons = document.querySelectorAll('.slide-glide button');

    buttons.forEach((button) => {
        button.onclick = function () {
            return false;
        };

        button.addEventListener('click', function () {

            //run opens methods,
            var inputopen = this.closest('.custom-control-label').parentElement.querySelector('input');
            inputopen.click()
            
            let valueOnClickButton = button.getAttribute('onclick');
            let regex = /window\.location\.href=['"](.+?)['"]/;
            let match = valueOnClickButton.match(regex);
            let url = "";
            if (match && match.length > 1) {
                url = match[1];
            }

            fetch(url)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    }
                    throw new Error('Network response was not ok.');
                })
                .then(function (data) {
                    if (divGlideParent.querySelector('.div-fetch')) {

                        divGlideParent.querySelector('.div-fetch').remove();
                    }
                    let newDiv = document.createElement("div");
                    newDiv.classList.add('div-fetch');
                    newDiv.innerHTML = data;
                    divGlideParent.appendChild(newDiv).scrollIntoView();
                    // window.scrollBy(0, 350); // dodać pare centymetrów do scrolla

                })
                .then(function (data) {
                    let panelActive = divGlideParent.closest('.panel');
                    let snippetElementWithButton;
                    if (document.querySelector('.form-builder-snippet-element .panel-button-next')) {

                        let buttonNext = document.querySelector('.form-builder-snippet-element .panel-button-next');
                        snippetElementWithButton = buttonNext.closest('.form-builder-snippet-element');

                    }
                    let listFormGroup = createList(panelActive);

                    showListButton(listFormGroup, snippetElementWithButton);
                })
                .then(function (data) {
                    myPriceHandler.initialize();
                })
                .catch(function (error) {
                    // console.log('Error:', error);
                });

        })
    });

}







